import { render, staticRenderFns } from "./mapping_details.vue?vue&type=template&id=4e3471fb&scoped=true"
import script from "./mapping_details.vue?vue&type=script&lang=js"
export * from "./mapping_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3471fb",
  null
  
)

export default component.exports